/**
 * Build CrossSellArea-shaped GTM grouping for a portal banner creative.
 * Keeps the same field names as seeded cross_sell_area rows.
 *
 * Prefer creativeSlotOverride from the display surface (page/slot).
 * Flag-based resolve is only a last-resort fallback.
 *
 * @param {object|null|undefined} banner
 * @param {string|null} creativeSlotOverride
 * @returns {object|null}
 */
export function bannerPromotionGrouping(banner, creativeSlotOverride = null) {
    const bannerId = banner?.banner_id

    if (! bannerId || banner?.is_default_left_hand) {
        return null
    }

    const bannerLabel = banner.label || `Banner ${bannerId}`

    return {
        creative_name: bannerLabel,
        creative_slot: creativeSlotOverride || resolveBannerCreativeSlotFallback(banner),
        item_list_name: bannerLabel,
        gtm_promotion_id: `BN_${bannerId}`,
        gtm_promotion_name: bannerLabel,
    }
}

/**
 * Last-resort slot from banner placement flags when no display context was passed.
 *
 * @param {object} banner
 * @returns {string}
 */
function resolveBannerCreativeSlotFallback(banner) {
    if (banner.left_hand_banner) {
        return 'homepage_left'
    }

    if (banner.right_hand_banner) {
        return 'homepage_right'
    }

    if (banner.category_banner) {
        return 'category_banner'
    }

    if (banner.show_on_core_pages) {
        return 'core_pages'
    }

    return 'banner'
}

/**
 * Slot for products shown inside a banner modal, tied to the page/surface that opened it.
 *
 * @param {string|null|undefined} displayCreativeSlot
 * @returns {string}
 */
export function bannerProductModalCreativeSlot(displayCreativeSlot = null) {
    if (! displayCreativeSlot) {
        return 'banner_product_modal'
    }

    return `${displayCreativeSlot}_product_modal`
}
